// 3rd party imports
import * as React from 'react';

// mobx
import { Program } from 'models';

// ui
import { UitkHeading } from 'uitk-react-text';
import { ILocalization } from '@shared-ui/localization-context';

export interface ProgramCardHeaderProps {
  program: Program;
  l10n?: ILocalization;
}

export const ProgramCardHeader: React.FunctionComponent<ProgramCardHeaderProps> = ({ program, l10n }) => {
  return (
    <UitkHeading tag="h3" size={5} align="center">
      {program.title}
    </UitkHeading>
  );
};
